__webpack_require__.p = "https://studentguru-dev.s3.amazonaws.com/frontend/";